import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { Column } from 'state/types'
import { getApiUrl } from '../../utils'

const baseUrl = getApiUrl('api')

// Define a service using a base URL and expected endpoints
export const columns = createApi({
  reducerPath: 'columnsApi',
  tagTypes: ['Columns'],
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      headers.set('x-api-key', process.env.REACT_APP_X_API_KEY)

      return headers
    },
    credentials: 'include',
    mode: 'cors'
  }),
  endpoints: ({ query, mutation }) => ({
    addColumns: mutation<Column, { dynamic_columns: Record<string, string | number> }>({
      query: (dynamic_columns) => {
        return {
          url: '/create_columns',
          method: 'POST',
          body: dynamic_columns,
        }
      },
      invalidatesTags: ['Columns']
    }),
    getColumns: query<Record<string, { dynamic_columns: Record<string, string | number> }>, string>({
      query: () => '/get_columns',
      providesTags: ['Columns']
    })
  }),
})

// TODO: https://stackoverflow.com/questions/61704805/getting-an-error-a-non-serializable-value-was-detected-in-the-state-when-using
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useAddColumnsMutation, useGetColumnsQuery, useLazyGetColumnsQuery } = columns
export const columnsApi = columns.endpoints